export default defineNuxtRouteMiddleware((to) => {
  if (!to.path.endsWith('/')) {
    let newPath = to.path + '/';

    if (Object.keys(to.query).length) {
      const query = new URLSearchParams(to.query as Record<string, string>);
      newPath += `?${query.toString()}`;
    }

    if (to.hash) {
      newPath += to.hash;
    }

    return navigateTo(newPath, { redirectCode: 301 });
  }
});
